import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  sidebarOpen: boolean;
  darkMode: boolean;
  selectedLocation: string | null;
}

const initialState: UIState = {
  sidebarOpen: true,
  darkMode: localStorage.getItem('darkMode') === 'true',
  selectedLocation: localStorage.getItem('selectedLocation') || null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
      localStorage.setItem('darkMode', state.darkMode.toString());
    },
    setSelectedLocation: (state, action: PayloadAction<string | null>) => {
      state.selectedLocation = action.payload;
      if (action.payload) {
        localStorage.setItem('selectedLocation', action.payload);
      } else {
        localStorage.removeItem('selectedLocation');
      }
    },
  },
});

export const { toggleSidebar, setSidebarOpen, toggleDarkMode, setSelectedLocation } = uiSlice.actions;
export default uiSlice.reducer;